export default __webpack_public_path__ + "static/media/food3x.fa40ecdf.png";